<!-- <app-widget-grid-card *ngIf="calendarWidgetExist" class="d-not-phone-none short-content">
    <div class="d-flex justify-content-end">
      <a href="#" (click)="toggleFullContent(true, $event)">{{widgetData.mobileOpenFullCalendarBtnText}}</a>
    </div>
  
    <div class="main-info">
      <div class="current-date">{{ currentDate | date: 'dd.MM' }}</div>
      <div class="text">
        {{ currentDate | dayOfWeek }}
        <span *ngIf="LocalizationService.showHebrewElements()" class="separator"></span> 
        <span *ngIf="LocalizationService.showHebrewElements()">{{ currentDate | hebrewMonth }}</span>
      </div>
    </div>
  
    <p class="description"></p> 
  
    <app-day-schedule [widgetData]="widgetData" [showFilters]="false" />
  </app-widget-grid-card> -->
  
<app-widget-grid-card
  *ngIf="calendarWidgetExist"
  class="mb-0 full-content"
  [mobileModal]="true"
  [open]="openedFull"
  (closeModal)="toggleFullContent(false)"
>
  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="tabChanged($event)" class="full-content-tabs">
    <mat-tab label="{{widgetData.tabDayBtnText}}">
      <app-my-day [widgetData]="widgetData" [selectedDay]="selectedDay"/>
    </mat-tab>

    <mat-tab label="{{widgetData.tabMonthBtnText}}">
      <app-my-month [widgetData]="widgetData" (dayItemClicked)="openDayDetails($event)"/>
    </mat-tab>
  </mat-tab-group>
</app-widget-grid-card>
